import qs from "qs";
import axios from "axios";

const url = process.env.VUE_APP_API_BASE_URL;

function init(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.post(`${url}/fe-init`, options)
    .then(response => {
      return response.data;
    });
}

export default {
  init
};

